import React, { useState, useEffect } from "react";
import { Button, Form, DatePicker, Input, Radio, Checkbox, Row, Col } from "antd";
import { component_tool, framework_tool } from '@/tool'
import moment from 'moment'
let { WizFileUpload, WizAvatarUpload } = framework_tool;
const { RangePicker, MonthPicker } = DatePicker;
const { Wizmessage } = component_tool

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

const Recommend = ({ form, data, submit, cancel, resetNum, ...props }) => {
  const platformList = [
    { value: 0, label: 'PC' },
    { value: 1, label: 'APP' },
    { value: 2, label: '凯迪拉克IQ' },
    { value: 3, label: '雪佛兰企微' },
    { value: 4, label: '别克企微' },
    { value: 5, label: '凯迪拉克企微' },
  ]
  const positionsList = [
    { value: 0, label: '首页轮播' },
    { value: 1, label: '广告位' },
    { value: 2, label: '路径推荐位' },
  ]

  // const [type, setType] = useState(data.fileType)
  const { getFieldDecorator, validateFields, setFields, resetFields, getFieldsValue, setFieldsValue } = form

  useEffect(() => {
    let { state, platforms, noticeWhitelist, startTime, endTime, carouselImg, advertisingImg, advertisingAppImg, pathImg, } = data
    setFieldsValue({
      state: state || 0,
      platforms: platforms || [],
      noticeWhitelist: noticeWhitelist || 0,
      time: startTime && endTime ? [moment(startTime), moment(endTime)] : [],
      carouselImg: carouselImg ? [{ fileId: carouselImg }] : [],
      advertisingImg: advertisingImg ? [{ fileId: advertisingImg }] : [],
      advertisingAppImg: advertisingAppImg ? [{ fileId: advertisingAppImg }] : [],
      pathImg: pathImg ? [{ fileId: pathImg }] : [],
    })
  }, [resetNum])

  formatImg = (values) => {
    if (values.carouselImg) {
      values.carouselImg = values.carouselImg[0]?.fileId
    }
    if (values.advertisingImg) {
      values.advertisingImg = values.advertisingImg[0]?.fileId
    }
    if (values.advertisingAppImg) {
      values.advertisingAppImg = values.advertisingAppImg[0]?.fileId
    }
    if (values.pathImg) {
      values.pathImg = values.pathImg[0]?.fileId
    }
    return values
  }
  const _submit = (pass) => {
    validateFields((err, values) => {
      if (!err) {
        if (pass === 3) {
          if (values.time?.length > 1) {
            values.startTime = values.time[0].format('YYYY-MM-DD hh:mm:ss')
            values.endTime = values.time[1].format('YYYY-MM-DD hh:mm:ss')
          }
          submit && submit(formatImg({ ...values }), 3, 'featured');
          // resetFields()
          return;
        } else {
          if (values.time?.length > 1) {
            values.startTime = values.time[0].format('YYYY-MM-DD hh:mm:ss')
            values.endTime = values.time[1].format('YYYY-MM-DD hh:mm:ss')
          }
          submit && submit(formatImg({ ...values }), 2, 'featured');
          // resetFields()
        }
        Wizmessage.success('保存成功')
      }
    });
  }
  formatLink = ({ fileType, fileId, address }) => {
    let newFileId = getOssFilePath(fileId[0]?.fileId || '')
    let fileOriginalName = fileId[0]?.fileOriginalName || ''
    if (fileType == 0) {
      return <a href={newFileId}>
        {fileOriginalName}
      </a>
    } else {
      return address
    }
  }
  checkChange = () => {

  }

  const { state = 0, platforms = [], positions = [], carouselImg, advertisingImg, advertisingAppImg, pathImg, startTime, endTime } = data || {}
  let initTime = []
  if (startTime && endTime) {
    initTime = [moment(startTime), moment(endTime)]
  }
  let initCarouselImg = carouselImg ? [{ fileId: carouselImg }] : []
  let initAdvertisingImg = advertisingImg ? [{ fileId: advertisingImg }] : []
  let initAdvertisingAppImg = advertisingAppImg ? [{ fileId: advertisingAppImg }] : []
  let initPathImg = pathImg ? [{ fileId: pathImg }] : []

  return (
    <>
      <Form {...formItemLayout}>
        <Form.Item label="是否推荐">
          {getFieldDecorator('state', {
            initialValue: state,
          })(<Radio.Group
          //   onChange={(e) => {
          //   setType(e.target.value)
          // }} value={type}
          >
            <Radio value={1}>是</Radio>
            <Radio value={0}>否</Radio>
          </Radio.Group>)
          }
        </Form.Item>
        {getFieldsValue().state == 1 ?
          <>
            <Form.Item label="推荐生效时间">
              {getFieldDecorator('time', {
                initialValue: initTime,
                rules: [{ required: true, message: '请选择推荐生效时间' }],
              })(
                <RangePicker showTime />
              )
              }
            </Form.Item>
            <Form.Item label="推荐平台">
              {getFieldDecorator('platforms', {
                initialValue: platforms,
                rules: [{ required: true, message: '请勾选推荐平台' }],
              })(<Checkbox.Group style={{ width: '100%' }}>
                <Row>
                  {platformList?.length > 0 && platformList.map(item => {
                    return (
                      <Col span={8}>
                        <Checkbox value={item.value}>{item.label}</Checkbox>
                      </Col>
                    )
                  })}
                </Row>
              </Checkbox.Group>,)
              }
            </Form.Item>
            <Form.Item label="推荐位">
              {getFieldDecorator('positions', {
                initialValue: positions,
                rules: [{ required: true, message: '请勾选推荐位' }],
              })(<Checkbox.Group style={{ width: '100%' }}>
                <Row>
                  {positionsList?.length > 0 && positionsList.map(item => {
                    return (
                      <Col span={8}>
                        <Checkbox value={item.value}>{item.label}</Checkbox>
                      </Col>
                    )
                  })}
                </Row>
              </Checkbox.Group>,)
              }
            </Form.Item>
            {getFieldsValue().positions.findIndex(x => x == 0) > -1 ?
              <Form.Item label="首页轮播图">
                {getFieldDecorator('carouselImg', {
                  initialValue: initCarouselImg,
                })(
                  <WizAvatarUpload
                    // key={record && record.carouselImg || ''}
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={400 / 207}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 1
                      if (!isLt1M) {
                        Wizmessage.error('首页轮播图片不得超过1MB!')
                      }
                      return isLt1M
                    }}
                  />
                )
                }
              </Form.Item>
              : null}
            {getFieldsValue().positions.findIndex(x => x == 1) > -1 ?
              <>
                <Form.Item label="PC广告图">
                  {getFieldDecorator('advertisingImg', {
                    initialValue: initAdvertisingImg,
                  })(
                    <WizAvatarUpload
                      // key={record && record.carouselImg || ''}
                      accept={'.jpg, .jpeg, .png'}
                      listType={'picture-card'}
                      aspectRatio={1140 / 167}
                      beforeUpload={(file) => {
                        const isLt1M = file.size / 1024 / 1024 < 1
                        if (!isLt1M) {
                          Wizmessage.error('首页轮播图片不得超过1MB!')
                        }
                        return isLt1M
                      }}
                    />
                  )
                  }
                </Form.Item>


                <Form.Item label="APP广告图">
                  {getFieldDecorator('advertisingAppImg', {
                    initialValue: initAdvertisingAppImg,
                  })(
                    <WizAvatarUpload
                      // key={record && record.carouselImg || ''}
                      accept={'.jpg, .jpeg, .png'}
                      listType={'picture-card'}
                      aspectRatio={464 / 136}
                      beforeUpload={(file) => {
                        const isLt1M = file.size / 1024 / 1024 < 1
                        if (!isLt1M) {
                          Wizmessage.error('首页轮播图片不得超过1MB!')
                        }
                        return isLt1M
                      }}
                    />
                  )
                  }
                </Form.Item>
              </>
              : null}
            {getFieldsValue().positions.findIndex(x => x == 2) > -1 ?

              <Form.Item label="路径推荐图">
                {getFieldDecorator('pathImg', {
                  initialValue: initPathImg,
                })(
                  <WizAvatarUpload
                    // key={record && record.carouselImg || ''}
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={400 / 207}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 1
                      if (!isLt1M) {
                        Wizmessage.error('首页轮播图片不得超过1MB!')
                      }
                      return isLt1M
                    }}
                  />
                )
                }
              </Form.Item>
              : null}
          </>
          : null}
        <Form.Item wrapperCol={{ span: formItemLayout?.wrapperCol?.span, offset: formItemLayout?.labelCol?.span }}>
          <Button type='primary' onClick={() => _submit(2)}>保存</Button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Button onClick={() => _submit(3)}>保存并关闭</Button>
        </Form.Item>
      </Form>
    </>
  )
}

let RecommendForm = Form.create()(Recommend)
export {
  RecommendForm,
}

